import { type ReactNode, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { AppPhase, useAppPhaseStore } from '../store/AppPhaseStore';
import { useSessionStore } from '../store/SessionStore';
import { useResourceStore } from '../store/ResourceStore';
import { setApiRoutes } from '../store/ApiRoutes';
import { DemoApiRoutes } from '../store/apiRoutes/DemoApiRoutes';
import { CapabilitiesProvider, DEMO_CAPABILITIES } from './capabilities';
import { clearPersistedStateStorage, setPersistenceEnabled } from '@gui/store/persistent/persistentStore';

export default function DemoAppBootstrap({ children }: { children: ReactNode }) {
    const phase = useAppPhaseStore((s) => s.phase);

    setApiRoutes(DemoApiRoutes);
    setPersistenceEnabled(false);
    clearPersistedStateStorage();

    useEffect(() => {
        (async () => {
            await useSessionStore.getState().authenticate();
            if (useSessionStore.getState().status !== 'authenticated') return;

            await useResourceStore.getState().fetchResources();
        })();
    }, []);

    if (phase === AppPhase.BOOT || phase === AppPhase.AUTHENTICATING || phase === AppPhase.LOADING_RESOURCES) {
        return (
            <CircularProgress
                size={100}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            />
        );
    }

    return <CapabilitiesProvider capabilities={DEMO_CAPABILITIES}>{children}</CapabilitiesProvider>;
}
